(function () {
  'use strict';

  if (window.FreeGiftPromo) return;

  class FreeGiftPromo {
    constructor() {
      const root = document.querySelector('[data-free-gift-promo]');

      this.variantId = root ? parseInt(root.dataset.giftVariantId, 10) : null;
      this.lineKey = root ? root.dataset.giftLineKey : null;
      this.productHandle = root ? root.dataset.productHandle : null;

      this.isRefreshing = false;
      this.pendingRefresh = false;

      if (!this.variantId) return;

      if (window.subscribe && window.PUB_SUB_EVENTS) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event && event.source === 'free-gift') return;

          this.updateGiftDataFromDom();
          this.syncPromoWidgets();
        });
      }

      this.syncPromoWidgets();
    }

    updateGiftDataFromDom() {
      const root = document.querySelector('[data-free-gift-promo]');

      if (!root) return;

      this.variantId = parseInt(root.dataset.giftVariantId, 10) || this.variantId;
      this.lineKey = root.dataset.giftLineKey || this.lineKey;
      this.productHandle = root.dataset.productHandle || this.productHandle;
    }

    async fetchSectionHtml(sectionId) {
      const res = await fetch(`${window.routes.cart_url}?section_id=${sectionId}`);
      const text = await res.text();

      return new DOMParser().parseFromString(text, 'text/html');
    }

    async syncPromoWidgets() {
      try {
        const fetches = [this.fetchSectionHtml('main-cart-items')];
        const hasDrawer = !!document.getElementById('CartDrawer');

        if (hasDrawer) {
          fetches.push(this.fetchSectionHtml('cart-drawer'));
        }

        const [cartItemsDoc, cartDrawerDoc] = await Promise.all(fetches);

        let latestWidget = null;

        const cartItemsTarget = document.querySelector('#main-cart-items [data-free-gift-promo]');
        const cartItemsWidget = cartItemsDoc && cartItemsDoc.querySelector('[data-free-gift-promo]');

        if (cartItemsTarget && cartItemsWidget) {
          cartItemsTarget.outerHTML = cartItemsWidget.outerHTML;
          latestWidget = cartItemsWidget;
        }

        if (hasDrawer) {
          const drawerTarget = document.querySelector('#CartDrawer [data-free-gift-promo]');
          const drawerWidget = cartDrawerDoc && cartDrawerDoc.querySelector('[data-free-gift-promo]');

          if (drawerTarget && drawerWidget) {
            drawerTarget.outerHTML = drawerWidget.outerHTML;
            latestWidget = latestWidget || drawerWidget;
          }
        }

        if (!latestWidget) return;

        this.variantId = parseInt(latestWidget.dataset.giftVariantId, 10) || this.variantId;
        this.lineKey = latestWidget.dataset.giftLineKey || this.lineKey;
        this.productHandle = latestWidget.dataset.productHandle || this.productHandle;

        const giftInCart = latestWidget.dataset.giftInCart === 'true';
        const qualifies = latestWidget.dataset.qualifies === 'true';

        if (giftInCart && !qualifies) {
          await this.removeGift(true);
        }
      } catch (error) {
        console.error(error);
      }
    }

    async removeGift(showMessage) {
      try {
        const lineIdentifier = this.lineKey || this.variantId;

        if (!lineIdentifier) return;

        const response = await fetch(window.routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            id: lineIdentifier,
            quantity: 0,
          }),
        });

        await response.json();

        await this.refreshCart('free-gift');

        if (showMessage) {
          this.announceGiftRemoved();
        }
      } catch (error) {
        console.error(error);
      }
    }

    async refreshCart(source) {
      if (this.isRefreshing) {
        this.pendingRefresh = true;
        return;
      }

      this.isRefreshing = true;

      try {
        await this.refreshSection('main-cart-items', '.js-contents', '#main-cart-items');
        await this.refreshSection('main-cart-footer', '.js-contents', '#main-cart-footer');
        await this.refreshCartDrawer();
        await this.refreshCartIconBubble();

        this.updateGiftDataFromDom();

        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: source || 'free-gift',
          });
        }
      } finally {
        this.isRefreshing = false;

        if (this.pendingRefresh) {
          this.pendingRefresh = false;
          this.refreshCart(source);
        }
      }
    }

    async refreshSection(sectionId, sourceSelector, targetSelector) {
      const target = document.querySelector(targetSelector);

      if (!target) return;

      try {
        const res = await fetch(`${window.routes.cart_url}?section_id=${sectionId}`);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const source = html.querySelector(sourceSelector);
        const destination = target.querySelector(sourceSelector) || target;

        if (source) {
          destination.innerHTML = source.innerHTML;
        }
      } catch (error) {
        console.error(error);
      }
    }

    async refreshCartDrawer() {
      const drawer = document.querySelector('cart-drawer');

      if (!drawer) return;

      try {
        const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const source = html.querySelector('#CartDrawer');
        const target = drawer.querySelector('#CartDrawer');

        if (source && target) {
          target.innerHTML = source.innerHTML;
          drawer.classList.toggle('is-empty', source.closest('.is-empty') !== null);
        }
      } catch (error) {
        console.error(error);
      }
    }

    async refreshCartIconBubble() {
      const target = document.getElementById('cart-icon-bubble');

      if (!target) return;

      try {
        const res = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const source = html.querySelector('.shopify-section');

        if (source) {
          target.innerHTML = source.innerHTML;
        }
      } catch (error) {
        console.error(error);
      }
    }

    announceGiftRemoved() {
      const message =
        (window.freeGiftStrings && window.freeGiftStrings.removedText) ||
        'Your free gift was removed because your cart no longer qualifies.';

      const liveRegion =
        document.getElementById('cart-live-region-text') ||
        document.getElementById('CartDrawer-LiveRegionText');

      if (liveRegion) {
        liveRegion.textContent = message;
        liveRegion.setAttribute('aria-hidden', 'false');

        setTimeout(() => {
          liveRegion.setAttribute('aria-hidden', 'true');
        }, 4000);
      }
    }
  }

  function init() {
    window.FreeGiftPromo = new FreeGiftPromo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();